module.exports = __webpack_public_path__ + "static/media/Sales_1.e51ba743.gif";